<script setup lang="ts">
  import {computed} from 'vue';
  import useCpBem from '~/composables/useCpBem';
  import CpButtonRound from '~/components/cp/CpButtonRound/CpButtonRound.vue';

  type AvatarSizeType = 'large'|'medium'|'small';
  const emit = defineEmits(['edit-avatar']);
  const props = withDefaults(defineProps<{
    size: AvatarSizeType
    image?: string
    edit?: boolean
    alt?: string
  }>(), {
    alt: '',
    image: undefined,
  });
  const {bm, e} = useCpBem('cp-avatar');
  const iconSize = computed(() => {
    return props.size === 'small' ?
        24 :
props.size === 'medium' ?
        48 :
120;
  });
  const editAvatar = () => {
    emit('edit-avatar');
  };
</script>

<template>
    <div :class="bm({[size]:true})">
        <div v-if="edit && size === 'large'" :class="e('edit-icon')" @click="editAvatar">
            <CpButtonRound icon="edit" type="primary-dark" />
        </div>
        <v-img v-if="image"
            :class="e('image')"
            :src="image"
            :alt="alt"
            cover
        />
        <div v-else :class="e('icon')">
            <v-icon icon="person" :size="iconSize" />
        </div>
    </div>
</template>

<style scoped lang="scss">
  .cp-avatar {
    position: relative;
    &__image {
      border-radius: 50%;
    }
    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background-color: var(--color-neutral-light);
      width: inherit;
      height: inherit;
    }
    &__edit-icon{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      background-color: var(--color-primary);
      border-radius: 50%;
      position: absolute;
      z-index: 2;
      right: 15px;
      top:15px
    }

    &--small {
      height: 32px;
      width: 32px;
    }
    &--medium {
      height: 64px;
      width: 64px;
    }
    &--large{
      height: 180px;
      width: 180px;
    }

    &:deep(.v-icon) {
      color: var(--color-icon);
    }
  }
</style>
